import { Box, Button, IconButton } from "@mui/material";
import React from "react";
import { useReactFlow } from "reactflow";
import ReplyIcon from "@mui/icons-material/Reply";
import EditIcon from "@mui/icons-material/Edit";
import NodeEdit from "./NodeEdit";
const ReplyButton = ({ id, data }) => {
  return (
    <Box>
      <NodeEdit id={id} />
      <Button
        fullWidth
        variant="contained"
        size="small"
        startIcon={<ReplyIcon />}
      >
        {data.text || "starter here..."}
      </Button>
    </Box>
  );
};

export default ReplyButton;
